module.exports = __webpack_public_path__ + "static/img/A137.5c8c95c1.jpg";